import { inspectPcmWav } from './audioDiagnostics.js';
import { PREPARED_LINE_BYTES } from '../core/preparedSpeech.js';

export function validSceneIntroPath(path) {
  return /^\/audio\/scene-intros\/v[12]\/[a-z0-9-]+-[1-9][0-9]*\.wav$/.test(path || '');
}

function pcmSamples(buffer) {
  inspectPcmWav(buffer);
  const bytes = new Uint8Array(buffer), view = new DataView(buffer);
  for (let offset = 12; offset + 8 <= bytes.length;) {
    const size = view.getUint32(offset + 4, true);
    if (String.fromCharCode(...bytes.subarray(offset, offset + 4)) === 'data') return bytes.subarray(offset + 8, offset + 8 + size);
    offset += 8 + size + size % 2;
  }
  throw new Error('The scene introduction is missing audio samples.');
}

// Preserve every original briefing sample. One buffer keeps the scheduled
// start, Pause/Resume, pitch-preserving speed and HTML fallback identical.
export function prependSceneIntro(intro, briefing) {
  const first = pcmSamples(intro), second = pcmSamples(briefing);
  const gap = 14400; // 300 ms at 24 kHz, mono PCM16.
  const size = 44 + first.length + gap + second.length;
  if (size > PREPARED_LINE_BYTES) throw new Error('The scene introduction and briefing exceed playback capacity.');
  const result = new ArrayBuffer(size), bytes = new Uint8Array(result), view = new DataView(result);
  const ascii = (offset, value) => [...value].forEach((letter, index) => { bytes[offset + index] = letter.charCodeAt(0); });
  ascii(0, 'RIFF'); view.setUint32(4, size - 8, true); ascii(8, 'WAVE'); ascii(12, 'fmt ');
  view.setUint32(16, 16, true); view.setUint16(20, 1, true); view.setUint16(22, 1, true);
  view.setUint32(24, 24000, true); view.setUint32(28, 48000, true); view.setUint16(32, 2, true); view.setUint16(34, 16, true);
  ascii(36, 'data'); view.setUint32(40, size - 44, true);
  bytes.set(first, 44); bytes.set(second, 44 + first.length + gap);
  return result;
}
